import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { stringProblems } from '../../data/practice/stringProblems';
import ProblemLayout from '../../components/ProblemLayout';

const StringProblem: React.FC = () => {
  const { problemId } = useParams<{ problemId: string }>();
  const problem = stringProblems.find(p => p.id === problemId);
  const [code, setCode] = useState(problem?.starterCode || '');

  if (!problem) {
    return <div>Problem not found</div>;
  }

  return (
    <ProblemLayout 
      title={problem.title}
      difficulty={problem.difficulty}
      tags={problem.tags}
      description={problem.description}
      hints={problem.hints}
      code={code}
      onCodeChange={setCode}
      onResetCode={() => setCode(problem.starterCode || '')}
      backUrl="/practice/strings"
      problemId={problemId || ''}
    />
  );
};

export default StringProblem;